// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4968":"17e78dd0","5863":"a9c206c5"}[chunkId] + ".chunk.css";
};